import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { mergeMap, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccountDto } from '@dto';
import { AccountService, SiteService } from 'src/app/services';

@Injectable({ providedIn: 'root' })
export class AccountResolver implements Resolve<AccountDto> {
  constructor(
    private accountService: AccountService,
    private siteService: SiteService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<AccountDto> {
    const accountId = route.queryParamMap.get('accountId') || route.paramMap.get('accountId');

    return this.accountService.getAccount$(accountId).pipe(
      mergeMap(account => {
        return this.siteService.getSites$(account.id).pipe(
          take(1),
          map(sites => ({ ...account, children: sites })),
        );
      }),
    );
  }
}
